// TODO this function could probably use a little cleanup.
const getTimeMetric = (timeInSeconds, metricTranslations) => {
    const timeInMinutes = Math.floor(timeInSeconds / 60);
    const timeInHours = Math.floor(timeInSeconds / 3600);
    if (!timeInSeconds) {
        return `0 ${metricTranslations.mins}`;
    }
    if (timeInSeconds < 60) {
        return `< 1 ${metricTranslations.min}`;
    }
    if (timeInSeconds > 60 && timeInSeconds < 3600) {
        return `${Math.floor(timeInMinutes)} ${timeInMinutes < 2 ? metricTranslations.min : metricTranslations.mins}`;
    }
    const remainderMin = Math.floor((timeInSeconds % 3600) / 60);
    const remainderMinString = remainderMin
        ? `, ${remainderMin} ${remainderMin < 2 ? metricTranslations.min : metricTranslations.mins}`
        : '';
    return `${timeInHours} ${timeInHours < 2 ? metricTranslations.hr : metricTranslations.hrs} ${remainderMinString}`;
};

export { getTimeMetric };
